export const voyagerStyles = {
  '.graphql-voyager': {
    position: 'relative',
  },
  '.loading-animation path': {
    fill: 'orange.500',
  },
  '.loading-animation h1': {
    color: 'orange.500',
  },
  '.doc-category > .item.-selected': {
    borderLeftColor: 'orange.400',
  },
  '.doc-navigation': {
    minHeight: '35px',
  },
  '.doc-navigation > .active': {
    color: 'orange.400',
  },
  '.doc-explorer-title-bar': {
    height: 'auto !important',
  },
  '.edge.highlighted path:not(.hover-path), .edge.hovered path:not(.hover-path), .edge:hover path:not(.hover-path)':
    {
      stroke: 'orange.500',
    },
  '.eye-button svg path:not([fill])': {
    fill: 'orange.400',
  },
  '.node polygon': {
    stroke: 'gray.550',
  },
  '.node.selected polygon': {
    stroke: 'orange.500',
  },
  '.node .type-title polygon': {
    fill: 'blue.500',
    stroke: 'blue.500',
  },
  '.node.selected .type-title polygon': {
    fill: 'orange.500',
    stroke: 'orange.500',
  },
  '.type-link': {
    color: 'orange.400',
    _hover: {
      color: 'orange.500',
    },
  },
  '.type-name.-input-obj, .type-name.-object': {
    color: 'orange.400',
    _hover: {
      color: 'orange.500',
    },
  },
  '.typelist-item.-root .type-name:after': {
    background: 'orange.500',
  },
  '.value-name': {
    color: 'orange.500',
  },
  '.arg-wrap > .arg > .default-value': {
    color: 'orange.500',
  },
  '.setting-other-options svg': {
    color: 'blue.500',
  },
}
